import { ThemeIcon } from '@mantine/core';

import type { IconTileViewProps } from './IconTile.types';

export function IconTileView({
  icon: Icon,
  iconSize = 14,
  stroke,
  color = 'blue',
  size = 'sm',
  radius = 'md',
  variant = 'light',
}: IconTileViewProps) {
  return (
    <ThemeIcon variant={variant} color={color} size={size} radius={radius}>
      <Icon size={iconSize} stroke={stroke} />
    </ThemeIcon>
  );
}
